export const customV43 = [
  {
    name: 'customV2_startPageV22',
  },
  {
    name: 'training_time',
  },
  {
    name: 'customV2_policyPageV3',
  },
  {
    name: 'customV2_gender',
  },
  {
    name: 'customV2_name',
  },
  {
    name: 'customV2_age',
  },
  {
    name: 'customV2_breed',
  },
  {
    name: 'customV2_health',
  },
  {
    name: 'customV2_info_breed',
  },
  {
    name: 'customV2_potty',
  },
  {
    name: 'customV2_issues',
  },
  {
    name: 'statement_irritation',
  },
  {
    name: 'customV2_walking_issues',
  },
  {
    name: 'customV2_activity',
  },
  {
    name: 'customV2_info_breed_2',
  },
  {
    name: 'customV2_command_1',
  },
  {
    name: 'statement_ignore_commands',
  },
  {
    name: 'customV2_reason',
  },
  {
    name: 'customV2_date',
  },
  {
    name: 'customV2_info_predict',
  },
  {
    name: 'customV2_training_time',
  },
  {
    name: 'customV2_training',
  },
  {
    name: 'age_group',
  },
  {
    name: 'statement_strong_bond',
  },
  {
    name: 'customV2_creating_program',
  },
  {
    name: 'customV2_plan',
  },
  {
    name: 'customV2_email',
  },
];
